import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import registerComponents from "@/helpers/registerComponents";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

/**
 * Axios
 */
Vue.use(VueAxios, axios);
axios.defaults.baseURL = "https://abtreibungsbot-qna.azurewebsites.net/qnamaker";

/**
 * Register all components globally (parentFolder-folder-componentName)
 */
registerComponents();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
